import React, { memo } from "react";
import useSmartphoneEventPreview from "./index.hooks";
import { Divider, Hidden, Typography } from "@material-ui/core";
import { Event } from "models";
import { AppPaper, EventPreview } from "components";
import EventBannerPlaceholder from "assets/images/event-image-placeholder.jpeg";

type SmartphoneEventPreviewProps = {
  event: Event;
  isInEditDialog?: boolean;
};

const SmartphoneEventPreview = ({
  event,
  isInEditDialog,
}: SmartphoneEventPreviewProps) => {
  const { styles, classes, atomicStyles } = useSmartphoneEventPreview();

  return (
    <Hidden smDown implementation="css">
      <div className={styles.container}>
        <div className={styles.smartphone}>
          <div className={styles.content}>
            <EventPreview event={event} isInEditDialog={isInEditDialog} />
          </div>
        </div>
      </div>
    </Hidden>
  );
};

export default memo(SmartphoneEventPreview);
